import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/pro-light-svg-icons/faCircleInfo';
import { TypedMemo } from '../../../common/types';
import { releaseMessages } from './releaseMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the release cards; each part uses its own slice of it */
import styles from './ReleaseCards.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface ClaimMatchNoteProps {
  /** The unreleased row that the claimed track looks like. */
  match: { uuid: string; title: string };
  /** True: the claim links the track to that row (`linkToItemUuid`). False: a new row. */
  isLinking: boolean;
  onChange: (isLinking: boolean) => void;
}

/**
 * Design g3, the blue note of the claim flow: the account has an unreleased row with the same
 * ISRC or the same title and artist. Linking keeps the master and the pre-save on one row.
 */
const ClaimMatchNoteComponent: React.FC<ClaimMatchNoteProps> = ({ match, isLinking, onChange }) => {
  const intl = useIntl();
  const chooseLink = useCallback(() => onChange(true), [onChange]);
  const chooseNew = useCallback(() => onChange(false), [onChange]);

  return (
    <div className={styles.note}>
      <FontAwesomeIcon icon={faCircleInfo} />
      <div>
        <b>{intl.formatMessage(releaseMessages.claimNoteTitle, { title: match.title })}</b>{' '}
        {intl.formatMessage(releaseMessages.claimNoteBody)}{' '}
        <button type="button" className={styles.noteLink} aria-pressed={isLinking} onClick={chooseLink}>
          {intl.formatMessage(releaseMessages.claimNoteLink, { title: match.title })}
        </button>
        {' · '}
        <button type="button" className={styles.noteLink} aria-pressed={!isLinking} onClick={chooseNew}>
          {intl.formatMessage(releaseMessages.claimNoteNew)}
        </button>
      </div>
    </div>
  );
};

export const ClaimMatchNote = TypedMemo(ClaimMatchNoteComponent);
